import React from 'react';
import { Star, Users, CheckCircle, Award } from 'lucide-react';
export function SocialProof() {
  return <section className="py-4 bg-transparent" data-id="element-192">
      <div className="container mx-auto px-6" data-id="element-193">
        <div className="flex flex-wrap justify-center gap-8 md:gap-16 items-center text-gray-400 text-sm md:text-base font-medium" data-id="element-194">
          <div className="flex items-center gap-3" data-id="element-195">
            <div className="flex text-orange-500" data-id="element-196">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-197" />)}
            </div>
            <span className="text-white font-bold" data-id="element-198">4.9/5</span> valoración
          </div>

          <div className="flex items-center gap-2" data-id="element-199">
            <Users className="w-5 h-5 text-orange-500" data-id="element-200" />
            <span data-id="element-201">Profesionales satisfechos de Argentina</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-202">
            <CheckCircle className="w-5 h-5 text-orange-500" data-id="element-203" />
            <span data-id="element-204">Material digital práctico y aplicable</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-205">
            <Award className="w-5 h-5 text-orange-500" data-id="element-206" />
            <span data-id="element-207">Diseñado para uso profesional</span>
          </div>
        </div>

        <div className="text-center mt-6 text-gray-500 text-sm italic" data-id="element-208">
          Elegido por profesionales que buscan ahorrar tiempo sin bajar la
          calidad de su intervención.
        </div>
      </div>
    </section>;
}